import type ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import ModelsContext from '@/lib/contexts/ModelsContext';
import { MenuItem, Select } from '@mui/material';
import { useContext } from 'react';
import SelectWrapper from './SelectWrapper';
import ModelSelectInfo from './ModelSelectInfo';
import { FormattedMessage, useIntl } from 'react-intl';

type ModelSelectProps = {
  variant: ModelType;
  selectedModelId: number | null;
  setSelectedModelId: (modelId: number) => void;
};

const ModelSelect = ({
  variant,
  selectedModelId,
  setSelectedModelId,
}: ModelSelectProps) => {
  const models = useContext(ModelsContext);
  const selectableModels = Object.values(models[variant]).filter(
    model => model.deactivatedAt === null,
  );

  const intl = useIntl();
  const modelNameFallback = intl.formatMessage({
    id: 'portfolio.create_portfolio_item.model_select.options.name_fallback',
  });

  if (selectableModels.length <= 1) {
    return null;
  }

  return (
    <SelectWrapper>
      <label id="model-select-label" htmlFor="model-select">
        <FormattedMessage id="portfolio.create_portfolio_item.model_select.label" />
      </label>
      <Select
        id="model-select"
        labelId="model-select-label"
        variant="standard"
        size="small"
        value={selectedModelId!}
        onChange={e => setSelectedModelId(e.target.value)}
      >
        {selectableModels.map(model => (
          <MenuItem value={model.id} key={model.id}>
            {model.name ?? modelNameFallback}
          </MenuItem>
        ))}
      </Select>
      <ModelSelectInfo variant={variant} />
    </SelectWrapper>
  );
};

export default ModelSelect;
